import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AnimatedContent = /*#__PURE__*/function (_React$Component) {
  function AnimatedContent() {
    var _this;
    _classCallCheck(this, AnimatedContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AnimatedContent, [].concat(args));
    _defineProperty(_this, "state", {
      blockIndex: 1
    });
    _defineProperty(_this, "intervalId", void 0);
    return _this;
  }
  _inherits(AnimatedContent, _React$Component);
  return _createClass(AnimatedContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.intervalId = setInterval(function () {
        _this2.setState(function (_ref) {
          var blockIndex = _ref.blockIndex;
          return {
            blockIndex: blockIndex === 3 ? 1 : blockIndex + 1
          };
        });
      }, 8000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.state.blockIndex) {
        case 1:
          return /*#__PURE__*/_jsxs("div", {
            className: styles['dots'],
            children: [/*#__PURE__*/_jsx("div", {
              className: styles['dot']
            }), /*#__PURE__*/_jsx("div", {
              className: styles['dot']
            }), /*#__PURE__*/_jsx("div", {
              className: styles['dot']
            })]
          });
        case 2:
          return /*#__PURE__*/_jsx("div", {
            className: styles['circle-text']
          });
        case 3:
          return /*#__PURE__*/_jsx("div", {
            className: styles['smile']
          });
        /* istanbul ignore next */
        default:
          return null;
      }
    }
  }]);
}(React.Component);